module.exports = __webpack_public_path__ + "static/media/plate5_phone.67c57fa8.png";